/**
 * Scrolls the chat log container so `target` sits at the top of its visible
 * area — WITHOUT moving any ancestor scroll container.
 *
 * `Element.scrollIntoView` scrolls EVERY scrollable ancestor, including
 * `overflow-hidden` layout boxes (e.g. the Messages content wrapper below the
 * Chat/Campaign/Feed tab bar). Those boxes have no scrollbar, so once nudged
 * the user can never scroll them back and the pane stays stuck with its top
 * controls clipped under the tab bar. Scrolling the chat container directly
 * avoids that.
 */
export const scrollChatToTarget = (
	scroller: HTMLElement | null,
	target: HTMLElement | null,
	behavior: ScrollBehavior = "auto"
): void => {
	if (!scroller || !target) {
		return;
	}

	const top =
		target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;

	scroller.scrollTo({ top, behavior });
};
